/**
 * Spanish copy for every state in which a number is shown but cannot be dialed.
 *
 * One module because the cell styling, the cell tooltip and the softphone panel
 * all have to agree on which reason is true -- "calling is off on this account"
 * and "you have no number assigned" send an administrator to two different
 * screens, and a rep reading the wrong one asks the wrong question.
 *
 * Unaccented on purpose: the rest of public_html/database/ is (edit_avatar's
 * "no es valido" and "ya no esta en Twilio", the column header "Estatus").
 *
 * There is deliberately no string for a customer number that is blank or
 * undialable. That cell renders plain and undecorated with no tooltip, because
 * there is nothing the rep can do about it from this page and a tooltip on
 * every blank cell is noise.
 */

/** No voice_agents row, or the token request failed outright. */
export const CALLING_UNAVAILABLE =
  "Las llamadas no estan disponibles en esta cuenta.";

/** Registered for incoming calls, but with no number to call out from. */
export const NO_CALLER_ID_ASSIGNED =
  "Este telefono no esta conectado en esta cuenta para hacer llamadas.";

/** Shown once beside the softphone panel, so the rep knows who to ask. */
export const NO_CALLER_ID_HINT =
  "Pidele a un administrador que te asigne un telefono para llamar.";
